module.exports = __webpack_public_path__ + "94483934e8b441cb764db2f478137195.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/special-conditions/fragil.png
// module id = 264
// module chunks = 0